import { useState } from "react";
import { useStore } from "zustand";
import { createStore } from "zustand/vanilla";
import { getInitialScheduleState } from "../utils/scheduleEditorMapping";

const EMPTY_SELECTED_SCHEDULE = {
  sch_id: null,
  scheduleTitle: "",
  scheduleNo: null,
};

const EMPTY_TARGET_SCHEDULE = {
  scheduleTitle: "",
  rowType: "",
};

const createScheduleEditorStore = () => createStore((set) => ({
  activeTab: 0,
  existingScheduleStep: 0,
  selectedScheduleType: "",
  selectedSchedule: EMPTY_SELECTED_SCHEDULE,
  initialTargetSchedule: EMPTY_TARGET_SCHEDULE,
  isRowTypeDisabled: false,
  autoTaggingModeOn: false,
  isSubmitting: false,

  reset: () =>
    set({
      activeTab: 0,
      existingScheduleStep: 0,
      selectedScheduleType: "",
      selectedSchedule: EMPTY_SELECTED_SCHEDULE,
      initialTargetSchedule: EMPTY_TARGET_SCHEDULE,
      isRowTypeDisabled: false,
      autoTaggingModeOn: false,
      isSubmitting: false,
    }),

  initialize: ({ row, editMode }) => {
    const initialState = getInitialScheduleState(row, editMode);

    set({
      activeTab: 0,
      existingScheduleStep: 0,
      selectedScheduleType: initialState.scheduleType,
      selectedSchedule: initialState.selectedSchedule,
      initialTargetSchedule: initialState.targetSchedule,
      isRowTypeDisabled: initialState.isRowTypeDisabled,
      autoTaggingModeOn: false,
      isSubmitting: false,
    });
  },

  setActiveTab: (activeTab) =>
    set({
      activeTab,
      existingScheduleStep: 0,
      selectedSchedule: EMPTY_SELECTED_SCHEDULE,
    }),

  setExistingScheduleStep: (existingScheduleStep) =>
    set({ existingScheduleStep }),

  setSelectedSchedule: (selectedSchedule) => set({ selectedSchedule }),

  setAutoTaggingModeOn: (autoTaggingModeOn) => set({ autoTaggingModeOn }),

  setSubmitting: (isSubmitting) => set({ isSubmitting }),
}));

// Each mounted editor owns its state. Closing another page's dialog must not
// reset an active P&L or breakdown editor.
export function useScheduleEditorStore() {
  const [store] = useState(createScheduleEditorStore);
  return useStore(store);
}
